import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class PayrollLayoutsFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async save() {
    const collection = this.view.getCollectionName();
    const object = this.object;
    try {
      this.upsertUseCase.execute(collection, object);
      this.showSuccess("Successfully saved");
    } catch (error) {
      this.showError(error.message);
      throw error;
    }
  }
}

export default PayrollLayoutsFormPresenter;
